export const EQ_FREQUENCIES=[60,250,1000,4000,12000];
export const EQ_PRESETS={Flat:[0,0,0,0,0],'Bass boost':[7,4,0,-1,-2],Vocal:[-2,-1,4,5,1],Jazz:[3,1,0,2,4],Electronic:[5,3,-1,3,5]};
export function normalizeEqualizer(input={}){
  const preset=input?.preset==='Custom'||Object.hasOwn(EQ_PRESETS,input?.preset)?input.preset:'Flat';
  const bands=preset==='Custom'&&Array.isArray(input?.bands)?EQ_FREQUENCIES.map((_,i)=>Number.isFinite(input.bands[i])?Math.max(-12,Math.min(12,input.bands[i])):0):[...(EQ_PRESETS[preset]||EQ_PRESETS.Flat)];
  return {enabled:input?.enabled===true,preset,bands};
}
